import reportIds from './reportIds';
import {feLogger} from './index';
import {PageSecuritySwitchEnum} from '@/Constant';

enum RepType {
    Click = 'click',
    Show = 'show',
}

// cdn服务异常回退源站机制触发
export const reportCdnFail = () => {
    feLogger({
        rep_id: reportIds.cdnFail,
        rep_type: RepType.Show,
        rep_params: {},
    });
};

// 文档推荐知识助手品牌栏点击
export const reportRecommendDocBrandClick = (data: {'page_id': string}) => {
    feLogger({
        rep_id: reportIds.recommendDocBrandClick,
        rep_type: RepType.Click,
        rep_params: {
            ...data,
        },
    });
};

// 文档禁止复制开关点击
export const reportDocForbidCopyClick = (value: PageSecuritySwitchEnum, type: 'doc' | 'repo') => {
    feLogger({
        rep_id: reportIds.docForbidCopySwitchClick,
        rep_type: RepType.Click,
        rep_params: {
            type,
            value,
        },
    });
};

// 顶部栏点击跳转个人主页
export const openPersonFromTop = () => {
    feLogger({
        rep_id: reportIds.personOpenFromTop,
        rep_type: RepType.Click,
    });
};

// 知识库成员列表点击跳转个人主页
export const openPersonFromRepoMember = () => {
    feLogger({
        rep_id: reportIds.personOpenFromRepoMember,
        rep_type: RepType.Click,
    });
};

// 部门知识库成员列表点击跳转个人主页
export const openPersonFromDepMember = () => {
    feLogger({
        rep_id: reportIds.personOpenFromDepMember,
        rep_type: RepType.Click,
    });
};

// UserTooltips点击跳转个人主页
export const openPersonFromUserTooltipIcon = () => {
    feLogger({
        rep_id: reportIds.openPersonFromUserTooltipIcon,
        rep_type: RepType.Click,
    });
};
// 新版个人卡片点击跳转个人主页
export const openPersonFromUserTooltipContent = () => {
    feLogger({
        rep_id: reportIds.openPersonFromUserTooltipContent,
        rep_type: RepType.Click,
    });
};
// 新版个人卡片点击文档list
export const docLinkFromUserTooltipContent = () => {
    feLogger({
        rep_id: reportIds.docLinkFromUserTooltipContent,
        rep_type: RepType.Click,
    });
};

// 目录树激活搜索
export const startSidebarSearch = (
    data: {
        name: 'active_search';
        'query_id': string;
        'doc_type': number | string;
    }
) => {
    feLogger({
        rep_id: reportIds.startSidebarSearch,
        rep_type: RepType.Click,
        rep_params: {
            ...data,
        },
    });
};

// 搜索结果渲染
export const renderSidebarSearchList = (
    data: {
        'name': 'query_process';
        'query_id': string;
        'query': string;
        'show_list_size': string;
        'show_list_detail': any[];
        'doc_type': string;
        'timestamp_fe_request': string;
        'timestamp_fe_response': string;
        'timestamp_render_start': string;
        'timestamp_render_end': string;
        }
) => {
    feLogger({
        rep_id: reportIds.renderSidebarSearchList,
        rep_type: RepType.Show,
        rep_params: {
            ...data,
        },
    });
};

// 点击搜索结果项
export const clickSidebarSearchListItem = (
    data: {
        'name': 'show_list_click' | string;
        'query_id': string;
        'query': string;
        'title': string;
        'creator': string;
        'doc_type': string;
        'pos_absolute': string;
        'doc_id': string;
        'KU_name': string;
        'KU_id': string;
        'last_update_time': string;
    }
) => {
    feLogger({
        rep_id: reportIds.clickSidebarSearchListItem,
        rep_type: RepType.Click,
        rep_params: {
            ...data,
        },
    });
};

// 点击搜索结果项
export const slideSidebarSearchListItem = (
    data: {
        'name': string;
        'query_id': string;
        'query': string;
        'total_screen': string;
    }
) => {
    feLogger({
        rep_id: reportIds.slideSidebarSearchListItem,
        rep_type: RepType.Show,
        rep_params: {
            ...data,
        },
    });
};

// 目录树搜索错误
export const sidebarSearchError = (
    data: {
        'name': string;
        'query_id': string;
        'query': string;
        'status_code': string;
        'error_msg': string;
    }
) => {
    feLogger({
        rep_id: reportIds.sidebarSearchError,
        rep_type: RepType.Click,
        rep_params: {
            ...data,
        },
    });
};

// 查看数据周报页面
export const statisticsWeekData = (data: {source: string}) => {
    return feLogger({
        rep_id: reportIds.showStatisticsWeekData,
        rep_type: RepType.Show,
        rep_params: {
            ...data,
        },
    });
};

// 统计页-切换时间选择器
export const clickStatisticsDatepicker = () => {
    return feLogger({
        rep_id: reportIds.changeStatisticsDatepicker,
        rep_type: RepType.Click,
        rep_params: {},
    });
};

// 统计页-切换表格与图表显示样式
export const clickStatisticsDepartData = () => {
    return feLogger({
        rep_id: reportIds.changeStatisticsDepartData,
        rep_type: RepType.Click,
        rep_params: {},
    });
};

export const showTemplateRecommendBuried = () => {
    return feLogger({
        rep_id: reportIds.showTemplateRecommend,
        rep_type: RepType.Show,
        rep_params: {},
    });
};

export const closeTemplateRecommendBuried = () => {
    return feLogger({
        rep_id: reportIds.closeTemplateRecommend,
        rep_type: RepType.Click,
        rep_params: {},
    });
};

export const showTemplatePreviewBuried = () => {
    return feLogger({
        rep_id: reportIds.showTemplatePreview,
        rep_type: RepType.Show,
        rep_params: {},
    });
};

export const usedTemplateBuried = (templateId: number, tepName: string, nodes: any) => {
    return feLogger({
        rep_id: reportIds.useTemplate,
        rep_type: RepType.Click,
        rep_params: {
            docid: templateId,
            title: tepName,
            nodes: nodes,
        },
    });
};
